module.exports = __webpack_public_path__ + "static/media/preview_bg.39e00748.png";